import { render } from "./ModalWrapper.vue?vue&type=template&id=1f95bac4"
import script from "./ModalWrapper.vue?vue&type=script&lang=js"
export * from "./ModalWrapper.vue?vue&type=script&lang=js"

import "./ModalWrapper.vue?vue&type=style&index=0&id=1f95bac4&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__